import React, { useEffect, useRef, useState } from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';
import uuid from 'react-uuid';

export default function ImagesUploader(props) {
    // props
    const {
        categoryImage,
        currentCategoryImage,
        setCurrentCategoryImage,

        setIsImageDeleted
    } = props

    // states
    const [imagesToBeDeleted, setImagesToBeDeleted] = useState([])

    // refs
    const addImgInputRef = useRef(null)

    // setting the default image if category image exists
    useEffect(() => {
        if (categoryImage) {
            const imageData = {
                id: uuid().replaceAll("-", ""),
                src: categoryImage,
                value: null
            }

            setCurrentCategoryImage(imageData) // setting the image
        }
    }, [categoryImage, setCurrentCategoryImage])

    // add image change
    const handleAddImageChange = ev => {
        if (ev?.target?.files?.length) {

            let file = ev.target.files[0];

            // initializing FileReader
            let reader = new FileReader();

            // reading data from the file
            reader.readAsDataURL(file);

            // on load
            reader.onload = function (ev) {
                const imageData = {
                    id: uuid().replaceAll("-", ""),
                    src: reader.result,
                    value: file
                }

                setCurrentCategoryImage(imageData) // setting the image
            };
            // on error
            reader.onerror = function () {
                console.log("error while getting file info ", reader.error);
            };
        }


    }

    // edit image
    const handleAddOrEditSelectedImage = (ev) => {
        ev.preventDefault()

        addImgInputRef.current.click()
    }

    // delete image
    const handleDeleteSelectedImage = (ev, id, imgSrc) => {
        ev.preventDefault()

        const filteredImgSrc = imgSrc.split("/")
        const actualPath = filteredImgSrc[filteredImgSrc.length - 1]

        // setting images to be deleted
        setImagesToBeDeleted([...imagesToBeDeleted, {
            id,
            actualPath
        }])

        setIsImageDeleted(true) // setting is image deleted
    }

    // handle restore deleted image
    const handleRestoreDeletedImg = (ev, id) => {
        ev.preventDefault()
        const updatedData = imagesToBeDeleted.filter(item => item.id !== id)

        // setting images to be deleted
        setImagesToBeDeleted(updatedData)

        setIsImageDeleted(false) // setting is image deleted
    }

    return (
        <div className="img-uploader-container">
            <div className="iuc-inner d-flex flex-wrap">
                {/* to select image */}
                <input
                    type="file"
                    accept="image/png, image/gif, image/jpeg"
                    hidden
                    multiple
                    ref={addImgInputRef}
                    onChange={handleAddImageChange}
                />

                {
                    /* item */
                    currentCategoryImage?.src ? (
                        <div className={`img-block position-relative ${imagesToBeDeleted.find(el => el.id === 12) ? "to-be-deleted" : ""}`}>
                            {/* img */}
                            <div className="img-main h-100 d-flex align-items-center justify-content-center">
                                <img src={currentCategoryImage?.src} alt={`img`} className="img-fluid img-fluid-height" />
                            </div>

                            {/* options */}
                            <div className={`options position-absolute h-100 w-100 d-flex flex-wrap`}>
                                {
                                    imagesToBeDeleted.find(el => el.id === 12) ? (
                                        <React.Fragment>
                                            {/* removed text */}
                                            <div className="removed-text st-fs-13 st-fw-600 w-100 align-self-center text-center">
                                                <p>Removed</p>
                                            </div>

                                            {/* restore */}
                                            <div className="restore-text w-100 align-self-end d-flex justify-content-center mb-1">
                                                <a href="/" className="d-flex text-decoration-none st-text-primary st-fs-13 st-fw-600"
                                                    onClick={ev => handleRestoreDeletedImg(ev, 12)}>
                                                    <FeatherIcon
                                                        icon="corner-up-left"
                                                        size="12"
                                                        className="icon position-relative me-1"
                                                        style={{ top: 3 }}
                                                    />
                                                    <span>Restore</span>
                                                </a>
                                            </div>
                                        </React.Fragment>
                                    ) : (
                                        // delete
                                        <div className="delete-icon d-flex ms-auto">
                                            <a href="/"
                                                className="delete st-round-btn st-btn-xs d-flex align-items-center justify-content-center me-1"
                                                title="Edit"
                                                onClick={handleAddOrEditSelectedImage}>
                                                <FeatherIcon
                                                    icon="edit-2"
                                                    size="14"
                                                    className="icon" />
                                            </a>

                                            {/* <a href="/"
                                                className="delete st-round-btn st-btn-xs d-flex align-items-center justify-content-center"
                                                title="Delete"
                                                onClick={ev => handleDeleteSelectedImage(ev, 12, "")}>
                                                <FeatherIcon
                                                    icon="trash-2"
                                                    size="14"
                                                    className="icon" />
                                            </a> */}
                                        </div>

                                    )
                                }
                            </div>
                        </div>
                    ) : null
                }

                {
                    /* add img */
                    true ? (
                        <React.Fragment>
                            <label
                                className={`add-img cursor-pointer ${currentCategoryImage?.src ? "has-category-image" : ""}`}
                                onClick={handleAddOrEditSelectedImage}>
                                <span className="d-flex flex-column align-items-center justify-content-center h-100 w-100 inner">
                                    {/* box */}
                                    <div className="icon-box d-flex align-items-center justify-content-center">
                                        <FeatherIcon
                                            icon="plus"
                                            size="20"
                                            className="icon st-text-primary position-relative" />
                                    </div>
                                    {/* text */}
                                    <p className="st-fs-13 st-fw-600 mt-2 st-text-primary">Upload Image</p>
                                </span>
                            </label>
                        </React.Fragment>
                    ) : null
                }
            </div>
        </div>
    )
}
